import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { TableColumn } from 'react-data-table-component';
import axios, { AxiosRequestConfig } from "axios";
import Swal from "sweetalert2";
import moment from 'moment';

import { ShowBlocker } from '../../Components/LoaderComponent/LoaderComponent';



import './UserManagement.css';
import { IUserDetails, UserManagementProps, UserManagementState } from './interface';
import DataGrid from '../../Components/DataGrid/DataGrid';
import CustomMaterialMenu from '../../Components/DataGrid/Plugins/CustomMaterialMenu/CustomMaterialMenu';
import ViewUser from './ViewUser/ViewUser';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import ProfileServices from '../../Services/ProfileServices';



class UserManagement extends React.Component<UserManagementProps, UserManagementState> {

    constructor(props_: any) {
        super(props_);

        this.state = {
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            userData: [],
            currentSortColumn: '',
            sortingDirection: ''

        }
    }

    private formColumns: TableColumn<IUserDetails>[] = [
        {
            name: 'Taxpayer Name',
            selector: (row: IUserDetails) => row.userName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: IUserDetails) => row.email,
            sortable: true,
        },

        {
            name: 'Mobile Number',
            selector: (row: IUserDetails) => row.mobileNumber,
            sortable: true,

        },
        {
            name: 'Masked SSN',
            selector: (row: IUserDetails) => 'XXX-XX-' + row.maskedSSN,
        },
        {
            name: 'Date',
            //selector: row => moment(row.payment_time).format('MM-DD-YYYY hh:mm A'),//hh:mm A on Do MMMM YYYY
            selector: (row: IUserDetails) => row.registeredDate ? moment(row.registeredDate).format('MM-DD-YYYY hh:mm A') : '-',//hh:mm A on Do MMMM YYYY
            sortable: true
        },
        {
            name: 'Action',
            cell: (row: IUserDetails) => <button
                className='Action-Btn'
                onClick={(event) => {
                    this.activateOrDeactivateUser(row);
                }}>
                {row.userStatusId == 2 ? 'Deactivate' : 'Activate'}
            </button>,
            allowOverflow: false,

            button: true,
        },
        // {
        //     cell: row => <CustomMaterialMenu
        //     fontSize="small"
        //     multiPopoverItems={ [
        //         {
        //             key: "form8821",
        //             label: "Submitted Form-8821 to IRS"
        //         },
        //         {
        //             key: "form433A",
        //             label: "Submitted Form-433A to IRS"
        //         }
        //     ]}
        //     onPopoverClick={(key_: string, label_: string) => {
        //         this.updateFormSubmission(row.userId, key_);
        //     }}
        // />,
        // allowOverflow: true,
        // button: true,
        // width: '56px'
        // }
    ];



    async componentDidMount() {
        ///... check token in local storage
        const accesstoken = await loadFromLocalStorage('accessToken');
        ///... if available get user details otherwise re-direct to login page
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getAllUsers();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/'
        }
    }

    updateFormSubmission(userId: string, key: string) {

        try {
            let url = process.env.REACT_APP_API_URL + 'admin/updateSubmission';
            ShowBlocker(true);
            axios
                .post(url, { userId: userId, formName: key })
                .then((response) => {
                    ShowBlocker(false);
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Updated IRS Submission successfully",
                    });

                }).catch((err) => {
                    ShowBlocker(false);
                });
        }
        catch (ex) {

        }

    }

    getAllUsers() {

        let pageIndex: number = (this.state.currentPage - 1);
        let sortingObj: any = {};
        if (this.state.currentSortColumn != '') {
            sortingObj['column'] = this.state.currentSortColumn;
            sortingObj['direction'] = this.state.sortingDirection;
        }
        let pagination: any = {
            "offset": (pageIndex * this.state.currentRowsPerPage),
            "limit": this.state.currentRowsPerPage,
            "sort": { ...sortingObj },
            "search": this.state.searchText
        };

        ProfileServices.getAllUsers(pagination, this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({ userData: resp.data, totalRows: resp.totalCount });
                });
            }
        });
    }

    activateOrDeactivateUser(row: IUserDetails) {

        let payload = {
            userId: row.userId,
            userStatus: row.userStatusId == 2 ? '3' : '2'
        };
        ProfileServices.updateUserStatus(payload, this.state.accessToken).then((r) => {
            if (r.ok) {
                r.json().then((resp) => {
                    this.getAllUsers();
                    Swal.fire({
                        icon: "success",
                        title: "Success",
                        text: "Updated user status successfully",
                    });
                });
            }
        });

    }


    identifySortingMapColumn(columnName: string) {
        let actualColName = '';
        switch (columnName) {
            case "Taxpayer Name":
                actualColName = 'userName';
                break;
            case "Email":
                actualColName = 'email';
                break;
            case "Mobile Number":
                actualColName = 'mobileNumber';
                break;
        }
        return actualColName;
    }

    public render() {
        return (
            <div className='body-sub-contianer table-container'>
                {/* <h1>Transaction Logs</h1> */}
                <DataGrid
                    title='User Management'
                    search='User Details'
                    columns={this.formColumns}
                    data={this.state.userData}
                    onSearch={(searchText_: string) => {
                        this.setState({
                            searchText: searchText_,
                            currentPage: 1
                        }, () => {
                            this.getAllUsers();
                        })
                    }}

                     onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                         this.setState({
                            currentPage: currentPage,
                            currentRowsPerPage: currentRowsPerPage
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    onChangePage={(page: number, totalRows: number) => {
                        console.log(page, totalRows);
                        this.setState({
                            currentPage: page
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    onSort={(column: any, direction) => {

                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => {
                            this.getAllUsers();
                        })
                    }}
                    // onRowClicked = {
                    //     (row)=> {
                    //         console.log(row);
                    //         const reactContainer = document.createElement('div');

                    //         Swal.fire({
                    //             title: 'Form Details',
                    //             html: reactContainer,
                    //             showConfirmButton: true,
                    //             customClass: {
                    //                 popup: "custom-swal-popup", // Add custom class to the popup
                    //               },
                    //             didOpen: () => {
                    //             // Render the React component into the container
                    //             console.log(row)
                    //             const root = createRoot(reactContainer);
                    //             root.render(<ViewUser userId= {row.userId} rowDetail={{...row}}/>);
                    //             },
                    //             willClose: () => {
                    //             // Clean up the React component when Swal is closed
                    //             if (reactContainer) {
                    //                 //reactContainer.unmount();
                    //               }
                    //             },
                    //         });
                    //     }
                    // }
                    pagination
                    paginationTotalRows={this.state.totalRows}
                />
            </div>
        )
    }
}

export default UserManagement